import type { VehicleType, UscContext } from "../../../shared-logic/types/UscCommonTypes";

export const USC_VEHICLE_INIT = "uscVehicle/init";
export const USC_VEHICLE_SET_REQUIRE_FETCH = "uscVehicle/setRequireFetch";
export const USC_VEHICLE_SET_TYPE = "uscVehicle/setType";
export const USC_VEHICLE_FETCH_FAILED = "uscVehicle/setFetchFailed";
export const USC_VEHICLE_SET_ID = "uscVehicle/setVehicleForSaleId";
export const USC_VEHICLE_SET_PRICE = "uscVehicle/setPrice";
export const USC_VEHICLE_SET_AGGREGATED_COUNT = "uscVehicle/setAggregatedVehicleCount";

export type InitVehicle = {
    type: typeof USC_VEHICLE_INIT;
    result: VehicleType | null;
    source: unknown | null;
};
type RequireFetch = { type: typeof USC_VEHICLE_SET_REQUIRE_FETCH; requireFetch: boolean };
type SetType = {
    type: typeof USC_VEHICLE_SET_TYPE;
    vehicleType: UscContext;
};
type SetFetchFailed = { type: typeof USC_VEHICLE_FETCH_FAILED; failed: boolean };
type SetVehicleForSaleId = { type: typeof USC_VEHICLE_SET_ID; id: string };
type SetVehiclePrice = { type: typeof USC_VEHICLE_SET_PRICE; price: VehicleType["price"] };
type SetAggregatedVehicleCount = { type: typeof USC_VEHICLE_SET_AGGREGATED_COUNT; count: number | null };

export const initVehicle = (result: VehicleType | null, source: unknown | null): InitVehicle => ({
    type: USC_VEHICLE_INIT,
    result,
    source,
});
export const setRequireVehicleFetch = (requireFetch: boolean): RequireFetch => ({
    type: USC_VEHICLE_SET_REQUIRE_FETCH,
    requireFetch,
});
export const setVehicleType = (vehicleType: UscContext): SetType => ({ type: USC_VEHICLE_SET_TYPE, vehicleType });
export const setVehicleFetchFailed = (failed: boolean): SetFetchFailed => ({ type: USC_VEHICLE_FETCH_FAILED, failed });
export const setVehicleForSaleId = (id: string): SetVehicleForSaleId => ({ type: USC_VEHICLE_SET_ID, id });
export const setVehiclePrice = (price: VehicleType["price"]): SetVehiclePrice => ({
    type: USC_VEHICLE_SET_PRICE,
    price,
});
export const setAggregatedVehicleCount = (count: number | null): SetAggregatedVehicleCount => ({
    type: USC_VEHICLE_SET_AGGREGATED_COUNT,
    count,
});

export type UscVehicleActionsType =
    | InitVehicle
    | SetType
    | RequireFetch
    | SetFetchFailed
    | SetVehicleForSaleId
    | SetVehiclePrice
    | SetAggregatedVehicleCount;
